import axios from 'axios';

export const takeByTarget = (target) => {
    let newURL = "/other/take_by_target/"+target;
    return axios.get(`${newURL}`, 
    //     {
    //     headers: { Authorization: token }
    // }
);
}